// extracted by mini-css-extract-plugin
export default {"row":"vp_JSkht","col":"vp_S54YD","clickable":"vp_Z6fpa","disabled":"vp_dydgb","blink":"vp_GlU2o","attentionBlink":"vp_h2PpV","silent":"vp_JO3ut"};